import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type Props = { imEvent: ImEventDto; customerSetting: CustomerSetting };

export const SupplementaryInfo: React.FC<Props> = ({
  imEvent,
  customerSetting
}) => {
  const {
    info: { showPrice }
  } = customerSetting;
  return (
    <Box>
      <Box>
        <Typography variant="caption">
          ※イベントの内容・日時・場所{showPrice ? '・料金' : ''}
          などは変更になる場合があります。
        </Typography>
      </Box>
      {imEvent.url && (
        <Box>
          <Typography variant="caption">
            ご参加される際は「イベント詳細を見る（参照URL）」をご確認ください。
          </Typography>
        </Box>
      )}
    </Box>
  );
};
